import $ from 'jquery';
import 'slick-carousel';

let sliderHome = {
    init() {
        sliderHome.slider();
        sliderHome.sliderLanding();

        var ww = $(window).width();

        if (ww > 800) {
            sliderHome.imageSize();
            $(window).resize(function () {
                sliderHome.imageSize();
            })
        }
    },
    slider() {
        var slides = $('.block-slider .slider .slide');
        $('.block-slider .slider').slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            infinite: true,
            speed: 500,
            fade: true,

        })
        // .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        //     slides.removeClass('slideIn');
        //     slides.eq(currentSlide).addClass('slideOut');
        //     slides.eq(nextSlide).addClass('slideNext');

        // }).on('afterChange', function(event, slick, currentSlide, nextSlide) {
        //     slides.removeClass('slideNext slideOut start');
        //     slides.eq(currentSlide).addClass('slideIn');
        // });

        setTimeout(function () {
            $('.block-slider .slider .slide img:nth-child(2)').addClass('active');
        }, 2000);
    },
    imageSize() {
        var wh = $(window).height();
        var ww = $(window).width();
        var hi = wh * 0.7;
        var wwhalf = ww * 0.43;


        if (hi > wwhalf) {
            $('.block-slider .slider').height(wwhalf + 'px');
            $('.block-slider .slider .image').height(wwhalf + 'px');
            $('.block-slider .slider .image').css('flex', '0 0 ' + wwhalf + 'px');
            $('.block-slider .slider .slick-dots').css('left', wwhalf + 205 + 'px');
        }
        if (hi < wwhalf) {
            $('.block-slider .slider').height(hi + 'px');
            $('.block-slider .slider .image').height(hi + 'px');
            $('.block-slider .slider .image').css('flex', '0 0 ' + hi + 'px');
            $('.block-slider .slider .slick-dots').css('left', hi + 205 + 'px');
        }

        if (ww > 1100) {
            if (hi > wwhalf) {
                $('.block-slider .slider .slick-dots').css('left', wwhalf + 205 + 'px');
            }
            if (hi < wwhalf) {
                $('.block-slider .slider .slick-dots').css('left', hi + 205 + 'px');
            }
        } else {
            if (hi > wwhalf) {
                $('.block-slider .slider .slick-dots').css('left', wwhalf + 125 + 'px');
            }
            if (hi < wwhalf) {
                $('.block-slider .slider .slick-dots').css('left', hi + 125 + 'px');
            }
        }
    },
    sliderLanding() {
        $('.slider-landing').slick({
            dots: true,
            customPaging: function (slider, i) {
                if (i > 9) {
                    return '<span>' + (i + 1) + '</span>';
                } else {
                    return '<span>0' + (i + 1) + '</span>';
                }

            },
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            infinite: true,
            speed: 1200,
            fade: true,
        });
    }
}

export default sliderHome;
